export default __webpack_public_path__ + "static/media/tumbass.d8fb8759.png";